import React from "react";
import classes from "./ImportantNoteComp.module.css";

export default function ImportantNoteComp(props) {
  return (
    <div className={classes.importantNote} style={props.style}>
      <p className={classes.noteText}>
        <strong>{props.caption}</strong>
        {props.text}
      </p>
    </div>
  );
}
